/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BigRock } from './BigRock';
import {
    BigRockFromJSON,
    BigRockFromJSONTyped,
    BigRockToJSON,
} from './BigRock';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface BigRocksResponse
 */
export interface BigRocksResponse extends Status {
    /**
     * 
     * @type {Array<BigRock>}
     * @memberof BigRocksResponse
     */
    bigRocks: Array<BigRock>;
}

/**
 * Check if a given object implements the BigRocksResponse interface.
 */
export function instanceOfBigRocksResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bigRocks" in value;

    return isInstance;
}

export function BigRocksResponseFromJSON(json: any): BigRocksResponse {
    return BigRocksResponseFromJSONTyped(json, false);
}

export function BigRocksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BigRocksResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'bigRocks': ((json['big_rocks'] as Array<any>).map(BigRockFromJSON)),
    };
}

export function BigRocksResponseToJSON(value?: BigRocksResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'big_rocks': ((value.bigRocks as Array<any>).map(BigRockToJSON)),
    };
}

